import React from "react";

import {
FaMapMarkerAlt,
FaPhoneAlt,
FaEnvelope,
FaFacebookF,
FaTwitter,
FaInstagram,
FaLinkedinIn,
FaGraduationCap,
FaArrowRight,
FaPaperPlane,
FaChevronRight,
FaClock,
FaAward,
FaBookOpen,
FaShieldAlt
} from "react-icons/fa";

import "./Footer.css";

export default function Footer() {


const currentYear = new Date().getFullYear();


return (

    <footer className="ria-footer">


        <div className="ria-footer-accent">

            <span></span>

            <span></span>

            <span></span>

        </div>



        <div className="ria-footer-main">


            <div className="ria-footer-brand-section">


                <div className="ria-footer-brand">


                    <div className="ria-footer-brand-icon">

                        <FaGraduationCap />

                    </div>


                    <div className="ria-footer-brand-text">

                        <h2>

                           
                            Excellent Kids Foundation
                           

                        </h2>


                        <span>

                            Excellence • Integrity • Innovation

                        </span>

                    </div>


                </div>



                <p className="ria-footer-description">

                    Empowering students through quality education,

                    technology-driven learning, and a nurturing

                    environment that prepares future leaders for

                    academic excellence and lifelong success.

                </p>



                <div className="ria-footer-values">


                    <div className="ria-footer-value">

                        <FaAward />

                        <span>

                            Excellence

                        </span>

                    </div>



                    <div className="ria-footer-value">

                        <FaBookOpen />

                        <span>

                            Knowledge

                        </span>

                    </div>



                    <div className="ria-footer-value">

                        <FaShieldAlt />

                        <span>

                            Integrity

                        </span>

                    </div>


                </div>



                <div className="ria-footer-social-area">


                    <span>

                        Follow Our School

                    </span>



                    <div className="ria-footer-social-links">


                        <a

                            href="#"

                            aria-label="Facebook"

                        >

                            <FaFacebookF />

                        </a>



                        <a

                            href="#"

                            aria-label="Twitter"

                        >

                            <FaTwitter />

                        </a>



                        <a

                            href="#"

                            aria-label="Instagram"

                        >

                            <FaInstagram />

                        </a>



                        <a

                            href="#"

                            aria-label="LinkedIn"

                        >

                            <FaLinkedinIn />

                        </a>


                    </div>


                </div>


            </div>



            <div className="ria-footer-navigation-section">


                <div className="ria-footer-column">


                    <div className="ria-footer-title">


                        <span className="ria-footer-title-icon">

                            <FaArrowRight />

                        </span>


                        <h3>

                            Quick Links

                        </h3>


                    </div>



                    <ul>


                        <li>

                            <a href="#home">

                                <FaChevronRight />

                                <span>

                                    Home

                                </span>

                            </a>

                        </li>



                        <li>

                            <a href="#about">

                                <FaChevronRight />

                                <span>

                                    About Us

                                </span>

                            </a>

                        </li>



                        <li>

                            <a href="#admissions">

                                <FaChevronRight />

                                <span>

                                    Admissions

                                </span>

                            </a>

                        </li>



                        <li>

                            <a href="#academics">

                                <FaChevronRight />

                                <span>

                                    Academics

                                </span>

                            </a>

                        </li>



                        <li>

                            <a href="#student-portal">

                                <FaChevronRight />

                                <span>

                                    Student Portal

                                </span>

                            </a>

                        </li>


                    </ul>


                </div>



                <div className="ria-footer-column">


                    <div className="ria-footer-title">


                        <span className="ria-footer-title-icon">

                            <FaBookOpen />

                        </span>


                        <h3>

                            Academic Services

                        </h3>


                    </div>



                    <ul>


                        <li>

                            <a href="#results">

                                <FaChevronRight />

                                <span>

                                    Online Results

                                </span>

                            </a>

                        </li>



                        <li>

                            <a href="#attendance">

                                <FaChevronRight />

                                <span>

                                    Attendance System

                                </span>

                            </a>

                        </li>



                        <li>

                            <a href="#learning">

                                <FaChevronRight />

                                <span>

                                    Learning Management

                                </span>

                            </a>

                        </li>



                        <li>

                            <a href="#calendar">

                                <FaChevronRight />

                                <span>

                                    School Calendar

                                </span>

                            </a>

                        </li>



                        <li>

                            <a href="#parent-portal">

                                <FaChevronRight />

                                <span>

                                    Parent Portal

                                </span>

                            </a>

                        </li>


                    </ul>


                </div>


            </div>



            <div className="ria-footer-contact-section">


                <div className="ria-footer-title">


                    <span className="ria-footer-title-icon">

                        <FaMapMarkerAlt />

                    </span>


                    <h3>

                        Contact Us

                    </h3>


                </div>



                <div className="ria-footer-contact-grid">


                    <div className="ria-footer-contact-card">


                        <div className="ria-footer-contact-icon">

                            <FaMapMarkerAlt />

                        </div>


                        <div>

                            <span>

                                Visit Us

                            </span>


                            <p>

                                Monrovia, Liberia

                            </p>

                        </div>


                    </div>



                    <div className="ria-footer-contact-card">


                        <div className="ria-footer-contact-icon">

                            <FaPhoneAlt />

                        </div>


                        <div>

                            <span>

                                Call Us

                            </span>


                            <p>

                                +231 000 000 000

                            </p>

                        </div>


                    </div>



                    <div className="ria-footer-contact-card">


                        <div className="ria-footer-contact-icon">

                            <FaEnvelope />

                        </div>


                        <div>

                            <span>

                                Email Us

                            </span>


                            <p>

                                info@excellentkids.com

                            </p>

                        </div>


                    </div>



                    <div className="ria-footer-contact-card">


                        <div className="ria-footer-contact-icon">

                            <FaClock />

                        </div>


                        <div>

                            <span>

                                Office Hours

                            </span>


                            <p>

                                Mon - Fri: 8:00 AM - 4:00 PM

                            </p>

                        </div>


                    </div>


                </div>


            </div>


        </div>



        <div className="ria-footer-connect">


            <div className="ria-footer-connect-content">


                <div className="ria-footer-connect-icon">

                    <FaEnvelope />

                </div>


                <div>

                    <h4>

                        Stay Connected

                    </h4>


                    <p>

                        Subscribe for school news, events, and important updates.

                    </p>

                </div>


            </div>



            <div className="ria-footer-newsletter">


                <input

                    type="email"

                    placeholder="Enter your email address"

                    aria-label="Email address"

                />


                <button

                    type="button"

                    aria-label="Subscribe to newsletter"

                >

                    Subscribe

                    <FaPaperPlane />

                </button>


            </div>


        </div>



        <div className="ria-footer-motto">


            <span></span>


            <p>

                Building Character. Inspiring Excellence. Shaping the Future.

            </p>


            <span></span>


        </div>



        <div className="ria-footer-bottom">


            <div className="ria-footer-bottom-inner">


                <p>

                    
                     © {currentYear} 
                     Excellent Kids Foundation. 
                   
                    All Rights Reserved.

                </p>



                <div className="ria-footer-bottom-links">


                    <a href="#privacy">

                        Privacy Policy

                    </a>


                    <span>

                        |

                    </span>


                    <a href="#terms">

                        Terms & Conditions

                    </a>


                    <span>

                        |

                    </span>


                    <a href="#support">

                        System Support

                    </a>


                </div>


            </div>


        </div>


    </footer>

);


}
